import { Component, OnInit, Input } from '@angular/core';

// ------------------------------------------------------
export interface ITagControl {
  loading: boolean;
  disabled: boolean;
  error: string;
}

@Component({
  selector: '[smart-tag]',
  template: require('./smart-tag.component.pug'),
  styles: [require('./smart-tag.component.css').toString()],
})
export class SmartTagComponent implements OnInit {
  @Input('enabled')
  enabled: boolean;

  @Input('title')
  title: string;
  @Input()
  icon: string = 'far fa-tag';
  @Input('data')
  data: any;
  @Input('onclick')
  onclick: onSmartTagCallback;
  @Input('controller')
  controller: ITagControl;
  @Input('color')
  color: boolean = true;
  @Input('disabled')
  disabled: boolean = false;
  @Input('theme')
  theme: string = null;
  @Input('fontSize')
  fontSize: number = 22;
  @Input('activeClass')
  activeClass: string = null;
  @Input('extraNgClass')
  extraNgClass: any = null;

  hasError: boolean = false;
  loading: boolean = false;

  // -------------------------------------------------------------------
  constructor() {}

  // -------------------------------------------------------------------
  ngOnInit() {
    // console.warn('INIT');
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    // console.warn('DESTROY');
  }

  // -------------------------------------------------------------------
  onSuccess() {
    this.loading = false;
    console.log('smart tag onSuccess!');
  }

  // -------------------------------------------------------------------
  onFailure() {
    this.hasError = true;
    this.loading = false;
    console.log('smart tag onFailure!');
    let tag = this;
    console.warn({ tag });
  }

  called = false;

  // -------------------------------------------------------------------
  getClass() {
    let newClass = {};

    if (this.hasError == false) {
      if (this.theme) {
        newClass[`badge-${this.theme}`] = this.enabled;
      } else {
        if (this.activeClass) {
          newClass[this.activeClass] = this.enabled;
        } else {
          newClass['badge-success'] = this.enabled;
        }
      }
      newClass['badge-light'] = !this.enabled;
    } else {
      newClass['badge-danger'] = true;
    }

    return { ...newClass, ...this.extraNgClass };
  }

  // -------------------------------------------------------------------
  iconClass() {
    let newClass = {};
    newClass[this.icon] = true;
    //newClass['text-info'] = this.called && !this.hasError;
    //newClass['text-danger'] = this.hasError;
    return newClass;
  }

  // -------------------------------------------------------------------
  clicked() {
    if (this.loading || this.disabled) {
      return; // don't accept clicks in transition state
    }

    this.called = true;
    this.hasError = false;
    this.loading = true;

    this.onclick(
      this.data,
      this.onSuccess.bind(this),
      this.onFailure.bind(this),
    );
  }
}
